<template>
  <div>
    <mainmenu></mainmenu>
    <div class="container">
    </div>
    <transition enter-active-class="animated fadeIn faster">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import MainMenu from "../../components/shared/main-menu/MainMenu.vue";
import { homeChildrenPath } from "../../routes";
export default {
  components: {
    mainmenu: MainMenu
  },
  data() {
    return {
    };
  },
  computed: {
    show() {
      return this.$route.name === "home";
    }
  },
  watch: {
    $route: function() {
      // Check if given route is true, if it is then hide title.
      const matchRoutes = homeChildrenPath.filter(
        route => route.name === this.$route.name
      );
      if (matchRoutes.length) {
        this.$store.dispatch("showTitle", true);
      } else {
        this.$store.dispatch("showTitle", false);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue